// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
import DateController from "./date_controller"
// TODO: tom-select暫時降版2.3.1，不然redactor會壞掉
import TomSelectController from "./tom_select_controller"
import RedactorController from "./redactor_controller"
import RedactorSnippetsController from './redactor/snippets_controller'
import ClipboardController from "./clipboard_controller"
import AutoSubmitController from "./auto_submit_controller"
import ImageUploadController from "./image_upload_controller"
import SetOptionsController from "./set_options_controller"
import RenderActivityAdminUsersTableController from "./render_activity_admin_users_table_controller"
import TextClampWithImageController from "./text_clamp_with_image_controller"

application.register("hello", HelloController)
application.register("date", DateController)
application.register("tom-select", TomSelectController)
application.register("redactor", RedactorController)
application.register('redactor--snippets', RedactorSnippetsController)
application.register("clipboard", ClipboardController)
application.register("auto-submit", AutoSubmitController)
application.register("image-upload", ImageUploadController)
application.register("set-options", SetOptionsController)
application.register("render-activity-admin-users-table", RenderActivityAdminUsersTableController)
application.register("text-clamp-with-image", TextClampWithImageController)